import React, { createContext, Key, useEffect, useState } from 'react';
import { useBreadcrumbRoutes, Wrapper } from '@maxtropy/components';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import DragResize from '@/components/DragResize';
import { Layout } from 'antd';
import StationTree from './StationTree';
import OverView from './OverView';

const { Content, Sider } = Layout;

export const EnergyMonitorContext = createContext<{ unitId?: number; deviceLedgerId?: number; deviceName?: string }>(
  {}
);
const EnergyMonitorTest: React.FC = () => {
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [siderWidth, setSiderWidth] = useState(260);
  const [openSider, setOpenSider] = useState(true); // 左侧树形toggle

  const [dragStatus, setDragStatus] = useState(false);
  const [unitId, setUnitId] = useState<number>(); // 用能
  const [deviceLedgerId, setDeviceLedgerId] = useState<number>(); // 设备台账id
  const [deviceName, setDeviceName] = useState<string>();

  const dragChange = (width: number) => {
    if (openSider) {
      setSiderWidth(width);
    }
  };

  // 选择树回调
  const changeTreeSelect = (value: Key[], info: any) => {
    if (info) {
      setUnitId(info.id);
      setDeviceLedgerId(info.deviceLedgerId);
      setDeviceName(info.name);
    }
  };
  return (
    <Wrapper routes={breadcrumbRoutes?.routes} hasPadding={false} className={styles.wrapper}>
      <EnergyMonitorContext.Provider value={{ unitId, deviceLedgerId, deviceName }}>
        <Layout className={styles.layout}>
          <Sider
            className={styles.siderDemo}
            width={openSider ? siderWidth : 0}
            style={{ transition: dragStatus ? 'none' : 'all 0.2s', background: 'var(--mx-module-bg-color)' }}
          >
            <DragResize init={260} dragChange={dragChange} dragStatus={setDragStatus} />
            <StationTree style={{ width: '100%' }} changeTreeSelect={changeTreeSelect} />
          </Sider>
          <Content className={styles.content} style={{ marginLeft: openSider ? 10 : 0 }}>
            <div className="toggleBtn" style={{ left: openSider ? -30 : 0 }} onClick={() => setOpenSider(!openSider)}>
              {openSider ? <LeftOutlined /> : <RightOutlined />}
            </div>
            <OverView />
          </Content>
        </Layout>
      </EnergyMonitorContext.Provider>
    </Wrapper>
  );
};

export default EnergyMonitorTest;
